import { observable, action } from 'mobx';

export class ConfirmPrompt {
	@observable togglePrompt = false;
	@observable promptMessage = '';
	@observable promptCallback = null;

	@action
	showPrompt(message, callback) {
		this.togglePrompt = true;
		this.promptMessage = message;
		this.promptCallback = callback;
	}

	@action
	closePrompt() {
		this.togglePrompt = false;
		this.promptMessage = '';
		this.promptCallback = null;
	}

	handleClick(choice) {
		switch (choice) {
			case 'ok': {
				this.promptCallback(false);
				break;
			}

			case 'cancel': {
				this.promptCallback(true);
				break;
			}
		}

		this.closePrompt();
	}
}

export default new ConfirmPrompt();



// WEBPACK FOOTER //
// ./src/state/ConfirmPrompt.js